<template>
  <div class="text-sm text-gray-800 space-y-1">
    <div class="flex gap-x-2">
      <span class="font-medium text-gray-600">{{ $t('date_columns_active') }}</span>
      <span class="text-gray-900 font-semibold">{{ activeDateColumnsLabel() }}</span>
    </div>

    <div class="flex gap-x-2">
      <span class="font-medium text-gray-600">{{ $t('progress_columns_active') }}</span>
      <span class="text-gray-900 font-semibold">{{ activeProgressColumnsLabel() }}</span>
    </div>


  </div>
</template>

<script>
export default {
  name: "TaskColumnSelectorDisplay",

  props: {
    configPage: {
      type: Object,
      required: true
    },
    activityGroups: {
      type: Array,
      default: () => []
    }
  },

  methods: {
    activeDateColumnsLabel() {
      const settings = this.configPage.settings || {};
      const columns = [];

      if (settings.baseLine) {
        columns.push(this.$t('baseline'));
      }
      if (settings.lastPlanned) {
        columns.push(this.$t('baseline_latest'));
      }
      if (settings.actual) {
        columns.push(this.$t('actual'));
      }

      return columns.length > 0 ? columns.join(', ') : this.$t('none_selected');
    },

    activeProgressColumnsLabel() {
      const settings = this.configPage.settings || {};
      const columns = [];

      if (settings.baseLineProgress) {
        columns.push(this.$t('baseline_progress'));
      }
      if (settings.lastPlannedProgress) {
        columns.push(this.$t('latest_planning_progress'));
      }
      if (settings.actualProgress) {
        columns.push(this.$t('executed1'));
      }

      return columns.length > 0 ? columns.join(', ') : this.$t('none_selected');
    },
  }
}
</script>

